import React, { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { HelpTypes, MiscType, ServiceTypes } from '@pharmaplan/common/helpers/Constants';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { CampaignStatusType } from '@pharmaplan/common';

import strings from '../../../localization';
import CreateNew from '../../common/CreateNew';
import CustomDropdown from '../../common/CustomDropdown';
import FilterSubmitButtons from '../../common/FilterSubmitButtons';
import genericClasses from '../../../theme/GenericClasses';
import CustomTextField from '../../common/CustomTextField';

import { styles } from './styles';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

let serviceBasedUser: Array<{ key: HelpTypes; label: string }> = [
  { key: HelpTypes.technicians, label: strings.technicians },
];

if (isSelfService) {
  serviceBasedUser = [
    { key: HelpTypes.technicians, label: strings.technicians },
    { key: HelpTypes.students, label: strings.pharmacyStudent },
  ];
}

interface ICampaignsHeader {
  formik: FormikProps<any>;
  handleReset: () => void;
  handleCreate: () => void;
}

const CampaignsHeader: FC<ICampaignsHeader> = ({
  formik,
  handleReset,
  handleCreate,
}) => {
  const UserTypesDropdown = [
    { key: MiscType.All, label: strings.all },
    { key: HelpTypes.pharmacy, label: strings.pharmacy },
    { key: HelpTypes.pharmacist, label: strings.pharmacist },
    ...serviceBasedUser,
    { key: HelpTypes.pharmacyAdmin, label: strings.pharmacyAdministrator },
  ];

  const campaignStatusDropdown = [
    { key: CampaignStatusType.Draft, label: strings.draft },
    { key: CampaignStatusType.Active, label: strings.active },
    { key: CampaignStatusType.Inactive, label: strings.inactive },
  ];

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.headerFont}>{strings.campaigns}</Typography>
        <CreateNew label={strings.createNew} onClick={handleCreate} />
      </Box>
      <Grid container lg={9} xs={12} alignItems="center" wrap="nowrap" sx={styles.filterContainer}>
        <Grid xs={4}>
          <CustomTextField
            formik={formik}
            name="campaign"
            label={strings.campaignName}
          />
        </Grid>
        <Grid xs={4} sx={genericClasses.filterMargin}>
          <CustomDropdown
            formik={formik}
            name="userType"
            label={strings.userType}
            menuItems={UserTypesDropdown.slice(0, -1)}
            showPlaceholder
          />
        </Grid>
        <Grid xs={4} sx={genericClasses.filterMargin}>
          <CustomDropdown
            formik={formik}
            name="status"
            label={strings.status}
            menuItems={campaignStatusDropdown}
            showPlaceholder
          />
        </Grid>
        <FilterSubmitButtons handleReset={handleReset} />
      </Grid>
    </Box>
  );
};
export default CampaignsHeader;
